import { GetOTPLink, OTPInput, ServerErrorMessage, useBehaviourState } from '@sravni/react-silent-authentication-form';
import React, { useEffect } from 'react';
import { Spinner } from '@sravni/react-design-system';
import { Link, Text } from '@sravni/react-design-system/lib/Typography';
import { FIELD_NAME } from '../../../constants';
import { ContentProps } from '../types';
import { OTPScreenTexts } from '../OTPScreen.texts';
import styles from './OTPScreen.module.scss';

export const OTPScreenContentMobile = (props: ContentProps) => {
    const { onGetOTPClick, onChangePhoneClick, onOTPScreenOpen } = props;

    const { isLoading } = useBehaviourState();

    useEffect(() => {
        onOTPScreenOpen?.();
    }, []);

    return (
        <>
            <OTPInput />

            {isLoading ? (
                <Spinner className={styles.spinner} />
            ) : (
                <>
                    <GetOTPLink
                        inputName={FIELD_NAME.OTP as React.ComponentProps<typeof GetOTPLink>['inputName']}
                        size={14}
                        className={styles.otpLink}
                        onClick={onGetOTPClick}
                    />

                    <Link onClick={onChangePhoneClick} className={styles.changePhoneLink} strong>
                        <Text size={14}>{OTPScreenTexts.ChangePhoneNumberLabel}</Text>
                    </Link>
                </>
            )}
            <ServerErrorMessage className="h-mt-12" />
        </>
    );
};
